import moment, { Moment } from 'moment';
import 'moment/locale/fr';

import { ApiDeliveryDay } from '../types/api-delivery-day.type';
import { DeliveryDay } from '../types/delivery-day.type';
import {
  API_DATE_FORMAT,
  DELIVERY_DATE_FORMAT,
  DRIVE_DELIVERY_SCHEDULE,
} from '../constants/delivery-schedule.constants';

const toLegacyTime = (time: string): string => time.replace(':', 'H');

const formatDeliveryDate = (date: Moment): string => date.clone().locale('fr').format(DELIVERY_DATE_FORMAT);

const buildDeliveryDay = (date: Moment, schedule: string): DeliveryDay => ({
  date,
  formattedDate: formatDeliveryDate(date),
  schedule,
});

export const formatDeliverySchedule = (from: string, to: string): string =>
  `${toLegacyTime(from)} - ${toLegacyTime(to)}`;

export const toDeliveryDay = (day: ApiDeliveryDay): DeliveryDay =>
  buildDeliveryDay(moment(day.date, API_DATE_FORMAT), formatDeliverySchedule(day.from, day.to));

export const toDeliveryDays = (days: ApiDeliveryDay[]): DeliveryDay[] => days.map(toDeliveryDay);

export const deliveryDayFromOrder = ({
  deliveryDate,
  deliverySchedule,
}: {
  deliveryDate: string;
  deliverySchedule: string;
}): DeliveryDay => buildDeliveryDay(moment(deliveryDate, API_DATE_FORMAT), deliverySchedule);

export const stringDateToDeliveryDay = (
  stringDate: string | Moment,
  schedule: string = DRIVE_DELIVERY_SCHEDULE
): DeliveryDay => buildDeliveryDay(moment(stringDate, API_DATE_FORMAT), schedule);
